import PropTypes from 'prop-types';

/**
 * Renderiza HTML libre del CMS legacy.
 * Tipos legacy soportados: 'richText' y 'html'.
 * En desktop limita ancho para mejor legibilidad.
 */
const RichTextBlock = ({ value }) => {
  if (!value?.html) return null;
  return (
    <section className='cms-block cms-block--rich-text py-6 md:py-6 lg:py-8'>
      <div
        className='w-full md:max-w-3xl lg:max-w-3xl mx-auto px-6 text-base md:text-base lg:text-lg leading-relaxed'
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: value.html }}
      />
    </section>
  );
};

RichTextBlock.propTypes = {
  value: PropTypes.shape({
    html: PropTypes.string,
  }).isRequired,
};

export default RichTextBlock;
